import { render, staticRenderFns } from "./examination-view.vue?vue&type=template&id=0f4e0ee8&scoped=true&"
import script from "./examination-view.vue?vue&type=script&lang=js&"
export * from "./examination-view.vue?vue&type=script&lang=js&"
import style0 from "./examination-view.vue?vue&type=style&index=0&id=0f4e0ee8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4e0ee8",
  null
  
)

export default component.exports